var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapMap',{staticStyle:{"width":"100%","height":"300px"},attrs:{"zoom":_vm.zoom,"center":_vm.center}},[_c('GmapMarker',{attrs:{"position":_vm.center}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }